export default __webpack_public_path__ + "static/media/chevron-gray.e101c7b9.svg";